const TableHeaderVerticalDivider = () => {
  return <div style={{ height: 20, borderLeft: '1px solid #e0e0e0', marginLeft: -8 }} />;
};

export default TableHeaderVerticalDivider;
